import './EnrollmentStatusView.less';
import React from 'react';
import statuses, {
    STATUS_PENDING,
    STATUS_ACTIVE,
    STATUS_INACTIVE
} from "../../model-constants/enrollment/statuses";
import Icon from "../../../bootstrap/components/icon/Icon";


export default function EnrollmentStatusView({value, showsLabel}) {

    const getStatusClass = () => {
        switch (value) {
            case STATUS_PENDING:
                return 'status-pending';
            case STATUS_ACTIVE:
                return 'status-active';
            case STATUS_INACTIVE:
                return 'status-inactive';
        }
    };

    const getStatusLabel = () => {
        return statuses.get(value).label;
    };

    return <div
        className={`enrollment-status-view ${getStatusClass()}`}
        aria-label={showsLabel ? undefined : getStatusLabel()}
    >
        <Icon name="disc"/>
        {
            showsLabel &&
            <div className="text">{getStatusLabel()}</div>
        }
    </div>;
}
